import {createSlice} from '@reduxjs/toolkit'
import {fetchCoupons} from './orderSummaryThunk'

const initialState = {
  coupons: {
    results: [],
    loading: false,
    error: null,
  },
}

const orderSummarySlice = createSlice({
  name: 'orderSummary',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCoupons.pending, state => {
        state.coupons.loading = true
        state.coupons.error = null
        state.coupons.results = []
      })
      .addCase(fetchCoupons.fulfilled, (state, action) => {
        state.coupons.loading = false
        state.coupons.error = null
        state.coupons.results = action.payload
      })
      .addCase(fetchCoupons.rejected, (state, action) => {
        state.coupons.loading = false
        state.coupons.error = action.payload ?? 'Failed to fetch coupons'
        state.coupons.results = []
      })
  },
})

export default orderSummarySlice.reducer
